<div class="split left">
  <header>
    <div class="main-header d-flex justify-content-between align-items-center">
      <div class="logo default-pointer" (click)="navigate()">
        <img src="../../assets/termhub-logo.png" class="header-termhub-logo" alt="Termhub" />
      </div>
    </div>
  </header>

  <div class="signup-body">
    <div>
      <span class="header-text">Log In</span>
    </div>
    <div class="title mt-3" [hidden]="!verified">
      <div class="green-title verified-message">
        <img src="../../assets/check-circle.png" class="body-circled-check" alt="Check" /> Your email has been verified!
      </div>
    </div>
    <div class="login-box">
      <div class="login-form mt-3">
        <p class="not-found mt-1" *ngIf="noAccount">Unable to find an account associated with this email and password.</p>
        <div class="mb-3" *ngIf="emailVerified === false && emailExist">
          <span class="is-invalid">This user is not verified.</span>
          <span> Would you like to <a class="form-link" [routerLink]="''" (click)="resendVerificationEmail()">Resend verification email</a>? </span>
        </div>
        <div class="mb-3" [hidden]="valid">
          This email is not yet verified. Would you like to
          <a href (click)="!!resendVerificationEmail()" class="form-link">resend the verification email?</a>
        </div>
        <div>
          <app-input
            [for]="'usernameInputFC'"
            label="Email"
            placeholder="Enter your email"
            type="email"
            [control]="emailFC"
            [required]="true"
            (keydown.enter)="onSubmit()"
            [hidden]="token && refreshToken && userId"
          ></app-input>
          <div class="form-group" [hidden]="!valid || (token && refreshToken && userId)">
            <div class="input-container h-fit-content">
              <app-input
                [for]="'passwordInputFC'"
                label="Password"
                placeholder="Enter your password"
                type="password"
                [control]="passwordFC"
                [required]="true"
                (keydown.enter)="onSubmit()"
              ></app-input>
            </div>
            <div class="password-maintenance">
              <a id="forgotPasswordLink1" class="form-link" [routerLink]="'/password-reset'">Forgot your password?</a>
            </div>
          </div>
          <p class="mt-1" *ngIf="token && refreshToken && userId">Getting user profile info .....</p>
          <div class="form-group">
            <app-button for="loginBtn" btnType="login" type="submit" [hidden]="!valid || (token && refreshToken && userId)" (click)="onSubmit()"
              >Log In</app-button
            >
            <app-button for="resendBtn" btnType="login" type="submit" [hidden]="!valid" [hidden]="valid" (click)="resendVerificationEmail()"
              >Resend email</app-button
            >
            <app-button for="googleLoginBtn" btnType="social-login" (click)="googleLogin()">
              <img
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4="
                alt="google icon"
                width="20"
              />Sign in with Google
            </app-button>
            <app-button for="microsoftLoginBtn" btnType="social-login" (click)="microsoftLogin()">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAeklEQVR4nO3UMQqAMBBE0QUL7+F5LOxyxlSewTvZj/10Q8AI/gfbBpb8pAoAPklt08j4eft5aGSKBRo3IBJK8IgNv1CKhAwJpUjIkFCKhGYnBPzd0m+NjJ+na9XIFAt0bkAklOARG36hFAkZEkqRkCGhFAnNTggA6g0PsZwml5fu+o4AAAAASUVORK5CYII="
                alt="microsoft icon"
                width="24"
              />
              Sign in with Microsoft
            </app-button>
          </div>
        </div>
      </div>
      <div *ngIf="!emailExist && !emailVerified && !noAccount && !(token && refreshToken && userId)" class="new-account mt-3">
        <div class="signup-link">
          <div>Don't have an account? <a class="form-link" [routerLink]="'/signup'">Sign Up</a></div>
        </div>
      </div>
      <div class="new-account mt-3">
        <div class="signup-link">
          <div [hidden]="!noAccount">Don't have an account? <a class="form-link" [routerLink]="'/signup'">Sign Up ></a></div>
          <a id="forgotPasswordLink2" [hidden]="!(emailExist === true && emailVerified === true)" class="form-link" [routerLink]="'/password-reset'"
            >Forgot your password?</a
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div class="split right tinted-image"></div>
